import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import { solutions } from '../Header/Header';
// import Container from 'components/Container';

import Collapsible from 'react-collapsible';

const Sidebar = ({ children, open, setOpen }) => {
  return (
    <Drawer
      open={open}
      onClose={() => setOpen(!open)}
      className="sidebar small-screen"
    >
      <ul>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/services">Services</Link>
        </li>
        <Collapsible trigger="Solutions">
          {solutions.map((category) => {
            return (
              // <Collapsible trigger={category.heading}>
              //   {category.items.map((inside) => {
              //     return (
              //       // inside.externalLink ? <a href={inside.externalLink} target="_blank" rel="noopener">{inside.name}</a> :<Link to={inside.link}>{inside.name}</Link>
              //       <Link to={inside.link}>{inside.name}</Link>
              //     );
              //   })}
              // </Collapsible>
              category.items.map((inside) => {
                return (
                  // inside.externalLink ? <a href={inside.externalLink} target="_blank" rel="noopener">{inside.name}</a> :<Link to={inside.link}>{inside.name}</Link>
                  <Link to={inside.link}>{inside.name}</Link>
                );
              })
            );
          })}
        </Collapsible>
        <li>
          <Link to="/products">Products</Link>
        </li>
        <li>
          <Link to="/pricing">Pricing</Link>
        </li>
        <li>
          <a href="https://meetrix.io/blog/" target="blank">
            Resources
          </a>
        </li>
        {/* <li>
              <Link to="/">Get Connected</Link>
            </li> */}
        <li>
          <Link to="/contact-us">Contact Us</Link>
        </li>
      </ul>
    </Drawer>
  );
};

Sidebar.propTypes = {
  children: PropTypes.node,
};

export default Sidebar;
